import styled from 'styled-components';

export const DropdownWrapper = styled.div`
  background: ${({ theme }) => theme.colors.primary.white};
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08),
    0 9px 28px 8px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  padding: 10px;
`;

export const DropdownElement = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 10px;
  border-radius: 8px;

  & > div:first-child {
    margin-right: 8px;
  }

  :hover {
    background: ${({ theme }) => theme.colors.tone.lightBlue};
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: fit-content;
  margin-right: 0;
  margin-left: auto;
`;
